import CheckBox from './CheckBox';
import Phone from './Phone';
import Select from './Select';
import TextArea from './TextArea';
import TextBox from './TextBox';
import CheckBoxToggle from './CheckboxToggle';
import Radio from './Radio';
import SelectCheck from './SelectCheck';

export { CheckBox, Phone, Select, TextArea, TextBox, CheckBoxToggle, Radio, SelectCheck };



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/components/index.tsx